module.exports = __webpack_public_path__ + "img/filter-2.60bed0c9.svg";